import * as React from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import { useEffect, useCallback, useState } from 'react';
import {
    Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { ReactComponent as DotMenu } from "../../../../assets/icons/dot-menu.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as View } from "../../../../assets/icons/view.svg";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";

const useStyles = makeStyles({
    btn: {
        fontSize: "18px !important",
        lineHeight: "24.59px !important",
        textDecoration: "underline !important",
        '& > svg': {
            marginLeft: "10px",
            marginBottom: "-2px",
        }
    },
    fillBlack: {
        width: "24px",
        height: "24px",
        '& > path': {
            fill: '#404349'
        },
        '& g > path': {
            fill: '#404349'
        },
    },
});

const styles = {
    td: {
        fontSize: "18px",
        lineHeight: "24.59px",
        textDecoration: "underline",
        '& > svg': {
            marginLeft: "10px",
            marginBottom: "-2px",
        }
    },
    iconBox: {
        width: "24px",
        height: "24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        marginRight: "12px"
    },
};

export default function DotMenuCompetencyMaster(props) {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const classes = useStyles();
    const { status, serial, linkGoToAddSub, linkGoToAddCompetency, linkGoToEdit, opens, subCategory, competency, cycle, isUsed } = props;
    // const [anchorEl, setAnchorEl] = React.useState(null);
    // const open = Boolean(anchorEl);
    const dispatch = useDispatch();
    const Planning = useSelector((state) => state.Planning);
    // useEffect(() => {
    //     setOpen(false);
    // status(false)
    // }, [closeMenu]);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
        // status((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
        // status(false)
    };
    const handleDel = (data) => {
        if (data === "del") {
            // onDel(row)
        }
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
            // status(false)
        } else if (event.key === 'Escape') {
            setOpen(false);
            // status(false)
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    const { t } = useTranslation()
    const onDeletePress = (evt, data) => {
        handleDel("del");
        handleConfirmDeleteDialog(true, data)
    }
    const adds = (value) => {
        // add(value)
    };
    let editAcc = () => {
        // onEdit();
    }
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const clickLinkView = (data) => {
        if (subCategory > 0) {
            navigate(`/admin/competency-sub-group/${serial}/${cycle}`, { replace: false });

        } else if (subCategory === 0 && competency > 0) {
            navigate(`/admin/competency-item/1/${serial}/${cycle}`, { replace: false });
        }
        navigate(data, { replace: false });
    }
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const handleConfirmDeleteDialog = (val, serial) => {
        openConfirmDeleteDialog(val);
    };
    const handleConfirmDeleteList = () => {
        props.delList(serial)
        openConfirmDeleteDialog(false)
    };
    useEffect(() => {
        setOpen(false)
    }, [opens]);
    // const handleDeleteClick = React.useCallback((e, data) => {
    //     e.stopPropagation();
    //     e.preventDefault();
    //     handleConfirmDeleteDialog(true, data)
    //   }, []);
    return (
        <Stack direction="row" spacing={2}>
            <DotMenu
                ref={anchorRef}
                id="composition-button"
                style={{ cursor: "pointer", "z-index": "1" }}
                onClick={handleToggle}
            />
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
                style={{ "z-index": "2" }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                        }}
                    >
                        <Paper sx={{ "margin-top": "5px !important" }}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    autoFocusItem={open}
                                    id="composition-menu"
                                    aria-labelledby="composition-button"
                                    onKeyDown={handleListKeyDown}
                                >
                                    {
                                        subCategory === 0 && competency === 0 ?
                                            <MenuItem disabled>
                                                <Box style={styles.iconBox}>
                                                    <View class={`${classes.fillBlack}`} />
                                                </Box>
                                                {t('label.view')}
                                            </MenuItem>
                                            :
                                            status === "active" ?
                                                <MenuItem onClick={() => clickLinkView()}>
                                                    <Box style={styles.iconBox}>
                                                        <View class={`${classes.fillBlack}`} />
                                                    </Box>
                                                    {t('label.view')}
                                                </MenuItem>
                                                :
                                                <MenuItem disabled>
                                                    <Box style={styles.iconBox}>
                                                        <View class={`${classes.fillBlack}`} />
                                                    </Box>
                                                    {t('label.view')}
                                                </MenuItem>
                                    }
                                    {subCategory > 0 ?
                                        status === "active" ?
                                            <MenuItem onClick={() => clickLink(linkGoToAddSub)}>
                                                <Box style={styles.iconBox}>
                                                    <PlusIcon class={`${classes.fillBlack}`} />
                                                </Box>
                                                {t('admin.label.addSubCategory')}
                                            </MenuItem>
                                            :
                                            <MenuItem disabled>
                                                <Box style={styles.iconBox}>
                                                    <PlusIcon class={`${classes.fillBlack}`} />
                                                </Box>
                                                {t('admin.label.addSubCategory')}
                                            </MenuItem>
                                        :
                                        competency > 0 ?
                                            <MenuItem disabled>
                                                <Box style={styles.iconBox}>
                                                    <PlusIcon class={`${classes.fillBlack}`} />
                                                </Box>
                                                {t('admin.label.addSubCategory')}
                                            </MenuItem>
                                            :
                                            status === "active" ?
                                                <MenuItem onClick={() => clickLink(linkGoToAddSub)}>
                                                    <Box style={styles.iconBox}>
                                                        <PlusIcon class={`${classes.fillBlack}`} />
                                                    </Box>
                                                    {t('admin.label.addSubCategory')}
                                                </MenuItem>
                                                :
                                                <MenuItem disabled>
                                                    <Box style={styles.iconBox}>
                                                        <PlusIcon class={`${classes.fillBlack}`} />
                                                    </Box>
                                                    {t('admin.label.addSubCategory')}
                                                </MenuItem>
                                    }
                                    {
                                        subCategory > 0 ?
                                            <MenuItem disabled>
                                                <Box style={styles.iconBox}>
                                                    <PlusIcon class={`${classes.fillBlack}`} />
                                                </Box>
                                                {t('admin.label.addCompetency')}
                                            </MenuItem>
                                            :
                                            status === "active" ?
                                                <MenuItem onClick={() => clickLink(linkGoToAddCompetency)}>
                                                    <Box style={styles.iconBox}>
                                                        <PlusIcon class={`${classes.fillBlack}`} />
                                                    </Box>
                                                    {t('admin.label.addCompetency')}
                                                </MenuItem>
                                                :
                                                <MenuItem disabled>
                                                    <Box style={styles.iconBox}>
                                                        <PlusIcon class={`${classes.fillBlack}`} />
                                                    </Box>
                                                    {t('admin.label.addCompetency')}
                                                </MenuItem>
                                    }
                                    <MenuItem onClick={() => clickLink(linkGoToEdit)}>
                                        <Box style={styles.iconBox}>
                                            <EditIcon class={`${classes.fillBlack}`} />
                                        </Box>
                                        {/* {t('label.edit')} */}
                                        Edit
                                    </MenuItem>
                                    {status === "active" ?
                                        <MenuItem disabled>
                                            <Box style={styles.iconBox} >
                                                <DeleteIcon class={`${classes.fillBlack}`} />
                                            </Box>
                                            {/* {t('label.delete')} */}
                                            Delete
                                        </MenuItem>
                                        : isUsed && status === "inactive" ?
                                            <MenuItem disabled>
                                                <Box style={styles.iconBox} >
                                                    <DeleteIcon class={`${classes.fillBlack}`} />
                                                </Box>
                                                {/* {t('label.delete')} */}
                                                Delete
                                            </MenuItem>
                                            :
                                            <MenuItem onClick={onDeletePress}>
                                                <Box style={styles.iconBox} >
                                                    <DeleteIcon class={`${classes.fillBlack}`} />
                                                </Box>
                                                {/* {t('label.delete')} */}
                                                Delete
                                            </MenuItem>
                                    }
                                </MenuList>
                            </ClickAwayListener>
                            <ConfirmDialog
                                open={isConfirmDeleteDialogOpen}
                                trash={true}
                                doConfirm={handleConfirmDeleteList}
                                setValue={handleConfirmDeleteDialog}
                                title={t('label.confirmationofDeletion')}
                                text={t('admin.label.confirmDeleteCompetencyMasterText')}
                            />
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </Stack>
    );
}